import { type PendingMembersTableColumnKey } from '@/features/iam/teams/PendingTeamMembersViewModel'
import { Avatar } from '@/components/Avatar'
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  type TableSortOrder,
} from '@/components/Table'
import styles from './PendingMembersTable.module.css'
import { dateFormatters } from '@/utils/date-util'

interface PendingMembersTableColumn {
  header: string
  key: PendingMembersTableColumnKey
  sortable?: boolean
}

const pendingMembersTableColumns: PendingMembersTableColumn[] = [
  {
    header: 'Email',
    key: 'email',
    sortable: true,
  },
  {
    header: 'Invited On',
    key: 'dateCreated',
    sortable: true,
  },
  {
    header: 'Invite Expiration',
    key: 'expires',
    sortable: true,
  },
]

export interface PendingMembersTableRow {
  email: string
  avatar: string | null
  dateCreated: Date
  expires: Date
}

export interface PendingMembersTableProps {
  rows: PendingMembersTableRow[]
  currentSort: PendingMembersTableColumnKey
  currentSortOrder: TableSortOrder
  onSort: (
    sortField: PendingMembersTableColumnKey,
    sortOrder: TableSortOrder,
  ) => void
}

export function PendingMembersTable({
  rows,
  currentSort,
  currentSortOrder,
  onSort,
}: PendingMembersTableProps) {
  return (
    <div>
      <Table striped stickyHeader>
        <TableHead>
          {pendingMembersTableColumns.map((col) => (
            <TableHeader
              key={col.key}
              canSort={col.sortable}
              sortOrder={col.key === currentSort ? currentSortOrder : 'none'}
              onSort={(newSort) => onSort(col.key, newSort)}
            >
              {col.header}
            </TableHeader>
          ))}
        </TableHead>
        <TableBody>
          {rows.map((pendingMember) => {
            return (
              <TableRow key={pendingMember.email}>
                <TableCell>
                  <div className={styles.memberItem}>
                    <div>
                      <Avatar
                        size={32}
                        subject={{
                          avatar: pendingMember.avatar,
                          displayName: pendingMember.email,
                        }}
                      />
                    </div>
                    <div className={styles.itemInfo}>
                      <p>{pendingMember.email}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  {dateFormatters.dateNumericPaddedDay.format(
                    pendingMember.dateCreated,
                  )}
                </TableCell>
                <TableCell>
                  {dateFormatters.dateNumericPaddedDay.format(
                    pendingMember.expires,
                  )}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}
